var $7TGaV$mocksse = require("mocksse");
var $7TGaV$preact = require("preact");


function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "iris_render", () => $536589213d45c66d$export$7c614d7487322a41);
$parcel$export(module.exports, "default", () => $536589213d45c66d$export$2e2bcd8739ae039);

function $03dfdd827e27320b$var$_extends() {
    return $03dfdd827e27320b$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $03dfdd827e27320b$var$_extends.apply(null, arguments);
}
// var isSmartphone = require('is-mobile')
var $03dfdd827e27320b$var$isShadowDomFontsInstalled = false;
const $03dfdd827e27320b$export$178b35fddc34acc2 = (data, eventsList)=>{
    try {
        // Check si l'evenement exist dans la liste
        if (eventsList[data.id] === undefined) throw `${data.id} n'est pas configur\xe9`;
        // Check si les données parents ne sont pas vides
        if (($03dfdd827e27320b$var$isEmptyObject(data) || data.zones[0].data && $03dfdd827e27320b$var$isEmptyObject(data.zones[0].data)) && eventsList[data.id].noData !== true) throw `${data.id} donn\xe9es manquantes`;
        // Check si les données enfants spécifiées dans 'check' sont présentes
        if (eventsList[data.id].check !== undefined && eventsList[data.id].check.length > 0) for (const key of eventsList[data.id].check){
            if (data.zones[0].data[key] !== undefined) {
                const keyData = data.zones[0].data[key];
                if (Array.isArray(keyData) && data.zones[0].data[key].length === 0) throw `${eventsList[data.id].elementId}: ${key} vide`;
                if (typeof keyData === 'object' && !Array.isArray(keyData) && $03dfdd827e27320b$var$isEmptyObject(data.zones[0].data[key])) throw `${eventsList[data.id].elementId}: ${key} vide`;
                if (typeof keyData === 'string' && data.zones[0].data[key] === '') throw `${eventsList[data.id].elementId}: ${key} vide`;
            } else throw `${key} non d\xe9finie`;
        }
        // Render du composant
        if (data.id === data.zones[0].id) {
            let Component = eventsList[data.id].component;
            let extraData = eventsList[data.id].data !== undefined ? eventsList[data.id].data : {};
            // Définition de l'id de la section
            let target = eventsList[data.id].elementId;
            if (eventsList[data.id].dynamicPosition === true && data.zones[0].data.position > 1) target = eventsList[data.id].elementId + '_' + data.zones[0].data.position;
            let targetNode = target === 'head' ? document.head : document.getElementById(target);
            // Injection les fonts en mode shadowdom
            if (eventsList[data.id].shadowDOM === true && $03dfdd827e27320b$var$isShadowDomFontsInstalled === false) {
                $03dfdd827e27320b$var$importFonts();
                $03dfdd827e27320b$var$isShadowDomFontsInstalled = true;
            }
            // Injection du shadowDOM
            if (eventsList[data.id].shadowDOM === true) {
                targetNode = targetNode.attachShadow({
                    mode: 'open'
                });
                const style = document.createElement('style');
                style.textContent = eventsList[data.id].shadowStyle;
                targetNode.appendChild(style);
            }
            if (eventsList[data.id].orchestrator !== undefined) eventsList[data.id].orchestrator(data, targetNode); // a decomissionné si pas utilisé
            else {
                // Rendu
                if (targetNode !== null) {
                    if (typeof eventsList[data.id].component === 'function') $03dfdd827e27320b$var$renderPreactComponent(Component, data, extraData, targetNode);
                    if (typeof eventsList[data.id].component === 'string') $03dfdd827e27320b$var$renderWebComponent(Component, data, extraData, targetNode);
                } else throw `La section #${target} n'existe pas dans la page`;
            }
        } else {
            if (typeof eventsList[data.id].component === 'function') $03dfdd827e27320b$var$updatePreactComponent(eventsList, data);
            if (typeof eventsList[data.id].component === 'string') $03dfdd827e27320b$var$updateWebComponent(eventsList, data);
        }
    } catch (error) {
        console.error(`Generic orchestrator de ${data.id} : `, error);
        document.dispatchEvent(new CustomEvent('sg1_incLog', {
            detail: 'Err_CORCH'
        }));
    }
};
const $03dfdd827e27320b$var$importFonts = ()=>{
    //injection d'une balise <style> avec le css de la font
    const fontStyle = document.createElement('style');
    fontStyle.textContent = `
       @font-face {
          font-family: 'icon-orange';
          src: url('https://cdn.woopic.com/18d8339538654b1dbf96a30e92745731/sg1/icon-orange.7b68951a83687c3a2fc2.woff2') format('woff2');
          font-weight: 400;
          font-style: normal;
          font-display: block;
       }
 
       @font-face{
          font-family:"o-HelveticaNeue";
          src:url('https://gp.cdn.woopic.com/fonts/HelvNeue55_W1G.woff2?20201014) format("woff2");
          font-weight:normal;
          font-style:normal;
          font-display:swap
        }
       
       @font-face{
          font-family: "o-HelveticaNeue";
          src: url('https://gp.cdn.woopic.com/fonts/HelvNeue75_W1G.woff2?20201014') format("woff2");
          font-weight: bold;
          font-style: normal;
          font-display: swap
       }
    `;
    document.head.appendChild(fontStyle);
};
const $03dfdd827e27320b$var$isEmptyObject = (obj)=>{
    for(var prop in obj){
        if (obj.hasOwnProperty(prop)) return false;
    }
    return JSON.stringify(obj) === JSON.stringify({});
};
const $03dfdd827e27320b$var$renderPreactComponent = (Component, data, extraData, targetNode)=>{
    (0, $7TGaV$preact.render)((0, $7TGaV$preact.h)(Component, $03dfdd827e27320b$var$_extends({}, data.zones[0].data, {
        eventId: data.id
    }, extraData)), targetNode);
};
const $03dfdd827e27320b$var$renderWebComponent = (webComponent, data, extraData, targetNode)=>{
    const harmonyElement = document.createElement(webComponent);
    const setAttributes = (obj)=>{
        Object.entries(obj).forEach(([key, value])=>{
            harmonyElement.setAttribute(key, typeof value === 'object' ? JSON.stringify(value) : value);
        });
    };
    [
        data.zones[0].data,
        extraData
    ].forEach(setAttributes);
    harmonyElement.setAttribute('event-id', data.id);
    targetNode.appendChild(harmonyElement);
};
const $03dfdd827e27320b$var$updatePreactComponent = (eventsList, data)=>{
    // Avec Signal
    if (eventsList[data.id].state !== undefined) {
        let value = {};
        value[data.zones[0].id] = data.zones[0].data;
        eventsList[data.id].state.value = value;
    }
};
const $03dfdd827e27320b$var$updateWebComponent = (eventsList, data)=>{
    const targetNodes = document.getElementsByTagName(eventsList[data.id].component);
    const targetNode = targetNodes.length > 0 ? targetNodes[0] : null;
    if (targetNode === null) throw `La section #${eventsList[data.id].elementId} n'existe pas dans la page`;
    // On met à jour les data attributs du webcomponent
    const dataAttributes = data.zones[0].data;
    Object.entries(dataAttributes).forEach(([key, value])=>{
        if (value !== undefined) targetNode.setAttribute(`${key}`, typeof value === 'object' ? JSON.stringify(value) : value);
    });
};


const $536589213d45c66d$export$7c614d7487322a41 = (config, profile, context)=>{
    try {
        if (config.loadHarmony === true) $536589213d45c66d$var$loadHarmony();
        $536589213d45c66d$var$renderPlaceholders(config);
        let SSE = $536589213d45c66d$var$SSEConnection(config, context, profile);
        let SSEResponseTime = new Date().getTime();
        if (SSE !== null) {
            SSE.addEventListener('renderEvent', (event)=>{
                try {
                    let data = event.data;
                    if (process.env.NODE_ENV === 'production') // condition webpack de COMPILATION pas de run coté client
                    data = JSON.parse(data);
                    else if ($536589213d45c66d$var$isForcedProd()) data = JSON.parse(data);
                    // DISPLAY RULES
                    // Execution de displayRules pour appliquer les règles metier d'affichage de la page si disponibles
                    if (config.displayRules && typeof config.displayRules === 'function') config.displayRules(config, data);
                    // RENDER
                    (0, $03dfdd827e27320b$export$178b35fddc34acc2)(data, config.events);
                } catch (error) {
                    console.error('Catch error: SSE renderEvent', {
                        error: error,
                        event: event
                    });
                }
            });
            SSE.addEventListener('redirection', (event)=>{
                if (event.data.location !== '') window.location.href = event.data.location;
            });
            // SSE Error
            SSE.addEventListener('error', (event)=>{
                console.error('SSE connexion error : ', JSON.parse(event.data).message);
            });
            // SSE EndOfTransmission
            SSE.addEventListener('EOT', (event)=>{
                SSE.close();
                let eotEvent = new CustomEvent(`sseEndOfTransmition`, {
                    detail: {
                        eot: true,
                        responseTime: new Date().getTime() - SSEResponseTime
                    }
                });
                document.dispatchEvent(eotEvent);
                $536589213d45c66d$var$removePlaceholders();
            });
        } else throw "SSE URL non d\xe9fini";
    } catch (error) {
        console.error('SG1.js', error);
        document.dispatchEvent(new CustomEvent('sg1_incLog', {
            detail: 'Err_PORCH'
        }));
    }
};

const $536589213d45c66d$var$SSEConnection = (config, context, profile)=>{
    let sseURL = config.sseURL;
    let SSE = null;
    // Mocks SSE
    if (process.env.NODE_ENV === 'development') {
        if (!$536589213d45c66d$var$isForcedProd() && config.mock !== null) {
            const { MockEvent: MockEvent, EventSource: EventSourceMock } = $7TGaV$mocksse;
            EventSource = EventSourceMock;
            new MockEvent(config.mock);
        }
    }
    // Connexion SSE
    // Ajout des éventuels paramètres de query string
    let queryString = window.location.search;
    if (queryString !== '' && context !== null) queryString += '&context=' + context;
    else if (queryString === '' && context !== null) queryString += '?context=' + context;
    if (sseURL.path[profile] === undefined) return null;
    let URL = sseURL.domain.default + '/' + sseURL.path[profile] + queryString;
    if (process.env.NODE_ENV === 'development') {
        if (!$536589213d45c66d$var$isForcedProd()) URL = '/';
        else URL = sseURL.domain.development + '/' + sseURL.path[profile] + queryString;
    } else if (sseURL.domain.exceptions && sseURL.domain.exceptions.length > 0) sseURL.domain.exceptions.forEach((exception)=>{
        exception.rules.forEach((rule)=>{
            if (window.location.hostname.indexOf(rule) !== -1) URL = exception.domain + '/' + sseURL.path[profile] + queryString;
        });
    });
    SSE = new EventSource(URL, {
        withCredentials: true
    });
    document.dispatchEvent(new CustomEvent('sg1_sseConnected', {
        detail: ''
    }));
    return SSE;
};
const $536589213d45c66d$var$removePlaceholders = ()=>{
    const placeholders = document.querySelectorAll('.placeholder');
    placeholders.forEach((placeholder)=>{
        placeholder.classList.remove('placeholder');
    });
    const placeholderStyle = document.getElementById('placeholderStyle');
    if (placeholderStyle) placeholderStyle.remove();
};
const $536589213d45c66d$var$renderPlaceholders = (config)=>{
    try {
        let placeholderStyle = '';
        // sortir tous les clé de config.events qui contiennent placeholder: true
        const placeholders = Object.keys(config.events).filter((key)=>config.events[key].placeholder);
        if (placeholders.length === 0) return;
        // pour chaque clé, poser la classe placeholder sur l'élément du DOM contenu dans config.events[key].elementId
        placeholders.forEach((key)=>{
            const element = document.getElementById(config.events[key].elementId);
            if (element !== null) {
                element.classList.add('placeholder');
                placeholderStyle += config.events[key].placeholderStyle;
            }
        });
        const placeholderNode = document.createElement('style');
        placeholderNode.id = 'placeholderStyle';
        placeholderNode.textContent = placeholderStyle;
        document.head.appendChild(placeholderNode);
    } catch (error) {
        console.error('Catch error: renderPlaceholders', {
            error: error
        });
    }
};
const $536589213d45c66d$var$isObject = (obj)=>{
    return null !== obj && 'object' === typeof obj;
};
const $536589213d45c66d$var$isForcedProd = ()=>{
    let isForcedProd = false;
    if (document.cookie.search('isForcedProd') !== -1) isForcedProd = true;
    return isForcedProd;
};
const $536589213d45c66d$var$loadHarmony = ()=>{
    const scriptModule = document.createElement('script');
    scriptModule.type = 'module';
    scriptModule.src = 'https://tools.cdn.woopic.com/harmony/harmony.esm.js';
    document.head.appendChild(scriptModule);
    const scriptNoModule = document.createElement('script');
    scriptNoModule.setAttribute('nomodule', '');
    scriptNoModule.src = 'https://tools.cdn.woopic.com/harmony/harmony.js';
    document.head.appendChild(scriptNoModule);
};
var // Export par défaut pour une meilleure compatibilité
$536589213d45c66d$export$2e2bcd8739ae039 = $536589213d45c66d$export$7c614d7487322a41;


//# sourceMappingURL=sg1-iris.js.map
